<template>
  <div>
    <h1>网校创建</h1>
    <el-form label-width="120px" @submit.native.prevent="save">
      <el-form-item label="网校名称">
        <el-input v-model="model.maName"></el-input>
      </el-form-item>
      <el-form-item label="MaID">
        <el-input v-model="model.maID"></el-input>
      </el-form-item>
      <el-form-item label="aid">
        <el-input v-model="model.aid"></el-input>
      </el-form-item>
      <el-form-item label="网校logo">
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/major/create/img'"
          :on-preview="handlePreview"
          list-type="picture"
          :on-success="maUpload"
        >
          <img :src="model.maImg" class="avatar" />
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>

    <h1>网校列表</h1>
    <el-table :data="major" style="width: 100%">
      <el-table-column
        prop="createAt"
        label="创建日期"
        :formatter="formatDate"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="maName" label="网校名称" width="180">
      </el-table-column>
      <el-table-column prop="maID" label="网校ID"> </el-table-column>
      <el-table-column prop="maImg" label="网校logo">
        <template slot-scope="scope">
          <div class="block">
            <el-avatar size="large" :src="scope.row.maImg"></el-avatar>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            @click="deleteMajor(scope.row.maID)"
            type="danger"
            size="small"
            plain
            icon="el-icon-delete"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";

export default {
  props: {
    maID: {},
  },
  data() {
    return {
      model: {},
      Dmajor: {},
      major: [],
    };
  },
  methods: {
    async save() {
      try {
        const result = await this.$http.post("/major/create", this.model);
        if (result.status === 200) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
        }
        this.getMajor();
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data.map((item) => {
          return {
            maID: item.maID,
            maImg: "/" + item.maImg,
            maName: item.maName,
            id: item._id,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    deleteMajor(maID) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.delete("/major/delmajor", {
            params: { maID: maID },
          });
          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getMajor();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    handlePreview(file) {
      //console.log(file);
    },
    maUpload(res) {
      try {
        this.model.maImg = res;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getMajor();
  },
};
</script>
